import { ApiMananger } from "actions/rtkquery";
import { GET_CLIENT_API_ROUTE } from "routes/api/endpoints";
import { INVALIDATE_CLIENT } from "../invalidationTags";

const clientApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({

    getClient: build.query({
        query: ({ dossier_id }) => `${GET_CLIENT_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_CLIENT],
    }),
    getClientId: build.query({
        query: ({ dossier_id, id }) => `${GET_CLIENT_API_ROUTE}?dossier_id=${dossier_id}&id=${id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_CLIENT],
    }),
}),
});

export const {
useGetClientQuery,
useGetClientIdQuery,
} = clientApi;
